module.exports = " <div class=person> <div class=person-thumb :style=\"'background-image:url(\\'' + person.photo + '\\')'\"></div> {{person.name}} {{person.twitter}} </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Person.vue
 ** module id = 53
 ** module chunks = 1
 **/